import React from 'react';
import { canBeCategorized, LiliTransaction } from '../../types/lili-transaction';
import { categoryTemplate } from '../cell-templates/transaction-category';

interface TransactionDetailsBucketsProps {
  transaction: LiliTransaction;
}

// Reuse the categoryTemplate function from the cell-templates/transaction-category.tsx file
// and wrap it the correct styling for the transaction details drawer
export const TransactionDetailsCategory = ({ transaction }: TransactionDetailsBucketsProps) => (canBeCategorized(transaction) ? (
  <div className='pb-[20px] border-b border-bw03'>
    {categoryTemplate(transaction, false, true)}
  </div>
) : null);
